'use strict';

var ByteBuffer = require('bytebuffer');
var usb = require('usb');
var transport = require('@onekeyfe/hd-transport');
var hdShared = require('@onekeyfe/hd-shared');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var ByteBuffer__default = /*#__PURE__*/_interopDefaultLegacy(ByteBuffer);
var usb__namespace = /*#__PURE__*/_interopNamespace(usb);
var transport__default = /*#__PURE__*/_interopDefaultLegacy(transport);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const { parseConfigure, ProtocolV1, check } = transport__default["default"];
const PACKET_SIZE = transport.PROTOCOL_V1_USB_PACKET_SIZE;
const REPORT_ID = transport.PROTOCOL_V1_REPORT_ID;
const PAYLOAD_SIZE = transport.PROTOCOL_V1_CHUNK_PAYLOAD_SIZE;
const HEADER_LENGTH = transport.PROTOCOL_V1_MESSAGE_HEADER_SIZE;
const INTERFACE_NUMBER = 0;
const ENDPOINT_IN = 0x81;
const ENDPOINT_OUT = 0x01;
const TRANSFER_TIMEOUT_MS = 30000;
const SERIAL_READ_TIMEOUT_MS = 5000;
const PACKET_IO_MAX_RETRIES = 3;
const PACKET_IO_RETRY_DELAY = 300;
const PROTOCOL_PROBE_TIMEOUT = 5000;
function getBusId(dev) {
    return `usb:${dev.busNumber}:${dev.deviceAddress}`;
}
function readSerialNumber(dev, openDevices) {
    const { iSerialNumber } = dev.deviceDescriptor;
    if (!iSerialNumber)
        return Promise.resolve(getBusId(dev));
    const busId = getBusId(dev);
    if (openDevices) {
        for (const [serial, od] of openDevices) {
            if (od.device === dev || getBusId(od.device) === busId) {
                return Promise.resolve(serial);
            }
        }
    }
    return new Promise(resolve => {
        let settled = false;
        const settle = (value) => {
            if (settled)
                return;
            settled = true;
            resolve(value);
        };
        const timer = setTimeout(() => {
            try {
                dev.close();
            }
            catch (_a) {
            }
            settle(busId);
        }, SERIAL_READ_TIMEOUT_MS);
        try {
            dev.open();
            try {
                dev.getStringDescriptor(iSerialNumber, (_err, data) => {
                    clearTimeout(timer);
                    try {
                        dev.close();
                    }
                    catch (_a) {
                    }
                    settle(data || busId);
                });
            }
            catch (_a) {
                clearTimeout(timer);
                try {
                    dev.close();
                }
                catch (_b) {
                }
                settle(busId);
            }
        }
        catch (_c) {
            clearTimeout(timer);
            settle(busId);
        }
    });
}
function skipReportByte(packet) {
    if (packet[0] === REPORT_ID) {
        return packet.subarray(1);
    }
    return packet;
}
function toArrayBuffer(buf) {
    return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
}
class NodeUsbTransport extends transport.ProtocolV2UsbTransportBase {
    constructor() {
        super({
            router: transport.PROTOCOL_V2_CHANNEL_USB,
            maxFrameBytes: transport.PROTOCOL_V2_FRAME_MAX_BYTES,
            logPrefix: 'ProtocolV2 NodeUSB',
        });
        this.name = 'NodeUsbTransport';
        this.version = '';
        this.configured = false;
        this.isOutdated = false;
        this.serialToBusId = new Map();
        this.openDevices = new Map();
        this.deviceProtocol = new Map();
        this.reconnectLocks = new Map();
        this.activeTransfers = new Map();
        this.cancelled = false;
    }
    init(logger, emitter) {
        this.Log = logger;
        this.emitter = emitter;
        return Promise.resolve('');
    }
    configure(signedData) {
        const messages = parseConfigure(signedData);
        this.configured = true;
        this.messages = messages;
        return Promise.resolve();
    }
    configureProtocolV2(signedData) {
        var _a;
        const schemaSource = typeof signedData === 'string'
            ? signedData
            : (_a = JSON.stringify(signedData)) !== null && _a !== void 0 ? _a : String(signedData);
        if (schemaSource === this.protocolV2SchemaSource)
            return;
        const hadProtocolV2Schema = this.protocolV2SchemaSource !== undefined;
        this.messagesV2 = parseConfigure(signedData);
        this.protocolV2SchemaSource = schemaSource;
        if (!hadProtocolV2Schema)
            return;
        this.invalidateAllProtocolV2UsbLinks('Protocol V2 schema reconfigured').catch(error => { var _a; return (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[NodeUsbTransport] schema link cleanup failed:', error); });
    }
    listen() {
    }
    stop() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.cancelled = true;
            yield this.cancelActiveTransfers();
            try {
                yield this.disposeProtocolV2UsbLinks('Node USB transport stopped');
            }
            catch (error) {
                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[NodeUsbTransport] stop link cleanup failed:', error);
            }
            yield Promise.allSettled(this.reconnectLocks.values());
            yield this.cancelActiveTransfers();
            yield Promise.all(Array.from(this.openDevices.keys(), path => this.closeOpenDevice(path)));
            this.reconnectLocks.clear();
            this.deviceProtocol.clear();
            this.serialToBusId.clear();
        });
    }
    post(path, name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.messages) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            if (this.deviceProtocol.get(path) === 'V2') {
                yield this.sendProtocolV2UsbFlowControl(path, name, data);
                return;
            }
            const encodeBuffers = ProtocolV1.encodeMessageChunks(this.messages, name, data);
            yield this.sendAllChunksWithRetry(path, encodeBuffers);
        });
    }
    read(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const dev = this.getOpenDevice(path);
            const resData = yield this.receiveData(path, dev);
            if (typeof resData !== 'string') {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.NetworkError, 'Returning data is not string.');
            }
            if (!this.messages) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            return ProtocolV1.decodeMessage(this.messages, resData);
        });
    }
    enumerate() {
        return __awaiter(this, void 0, void 0, function* () {
            const allDevices = usb__namespace.getDeviceList();
            const onekeyDevices = allDevices.filter(d => {
                const { idVendor, idProduct } = d.deviceDescriptor;
                return hdShared.ONEKEY_WEBUSB_FILTER.some(f => idVendor === f.vendorId && idProduct === f.productId);
            });
            const newSerialToBusId = new Map();
            const results = [];
            for (const d of onekeyDevices) {
                const busId = getBusId(d);
                const serial = yield readSerialNumber(d, this.openDevices);
                newSerialToBusId.set(serial, busId);
                results.push({
                    path: serial,
                    id: serial,
                    name: 'OneKey',
                    commType: 'usb',
                    debug: false,
                });
            }
            this.serialToBusId = newSerialToBusId;
            return results;
        });
    }
    acquire(input) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            this.cancelled = false;
            const path = (_a = input.path) !== null && _a !== void 0 ? _a : '';
            if (!path) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, 'No device path provided');
            }
            try {
                yield this.rotateProtocolV2UsbGeneration(path, 'Node USB transport acquired');
                yield this.closeOpenDevice(path);
                yield this.openDevice(path);
                const descriptor = this.getOpenDevice(path).device.deviceDescriptor;
                const protocolHint = input.expectedProtocol
                    ? undefined
                    : (_b = input.protocolHint) !== null && _b !== void 0 ? _b : hdShared.inferProtocolHintFromUsbId(descriptor.idVendor, descriptor.idProduct);
                yield this.detectProtocol(path, input.expectedProtocol, protocolHint);
                return path;
            }
            catch (error) {
                (_c = this.Log) === null || _c === void 0 ? void 0 : _c.debug('NodeUsbTransport acquire error: ', error);
                try {
                    yield this.release(path);
                }
                catch (cleanupError) {
                    (_d = this.Log) === null || _d === void 0 ? void 0 : _d.debug('NodeUsbTransport acquire cleanup error: ', cleanupError);
                }
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, (_e = error.message) !== null && _e !== void 0 ? _e : String(error));
            }
        });
    }
    release(path, _onclose) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cancelActiveTransfers(path);
            yield this.invalidateProtocolV2UsbLink(path, 'Node USB transport released');
            yield this.closeOpenDevice(path);
            this.deviceProtocol.delete(path);
        });
    }
    cancelActiveTransfers(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const transfers = Array.from(this.activeTransfers.entries()).filter(([, active]) => path === undefined || active.path === path);
            transfers.forEach(([transfer]) => {
                try {
                    transfer.cancel();
                }
                catch (_a) {
                }
            });
            yield Promise.allSettled(transfers.map(([, active]) => active.settled));
        });
    }
    createTrackedTransfer(path, endpoint, callback) {
        let resolveSettled = () => undefined;
        const settled = new Promise(resolve => {
            resolveSettled = resolve;
        });
        const transfer = endpoint.makeTransfer(endpoint.timeout, (error, buffer, actualLength) => {
            this.activeTransfers.delete(transfer);
            resolveSettled();
            callback(error, buffer, actualLength);
        });
        this.activeTransfers.set(transfer, { path, settled, resolveSettled });
        return transfer;
    }
    transferInOnce(path, ep, length) {
        return new Promise((resolve, reject) => {
            const buffer = Buffer.alloc(length);
            const transfer = this.createTrackedTransfer(path, ep, (error, _submittedBuffer, actualLength) => {
                if (error) {
                    reject(error);
                    return;
                }
                if (actualLength <= 0) {
                    reject(new Error('Empty USB transfer'));
                    return;
                }
                resolve(buffer.subarray(0, actualLength));
            });
            try {
                transfer.submit(buffer);
            }
            catch (error) {
                const active = this.activeTransfers.get(transfer);
                this.activeTransfers.delete(transfer);
                active === null || active === void 0 ? void 0 : active.resolveSettled();
                reject(error);
            }
        });
    }
    transferOutOnce(path, ep, data) {
        return new Promise((resolve, reject) => {
            const transfer = this.createTrackedTransfer(path, ep, error => {
                if (error) {
                    reject(error);
                    return;
                }
                resolve();
            });
            try {
                transfer.submit(data);
            }
            catch (error) {
                const active = this.activeTransfers.get(transfer);
                this.activeTransfers.delete(transfer);
                active === null || active === void 0 ? void 0 : active.resolveSettled();
                reject(error);
            }
        });
    }
    closeOpenDevice(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const openDev = this.openDevices.get(path);
            if (!openDev)
                return;
            try {
                yield new Promise(resolve => {
                    openDev.iface.release(() => {
                        try {
                            openDev.device.close();
                        }
                        catch (_a) {
                        }
                        resolve();
                    });
                });
            }
            catch (_a) {
                try {
                    openDev.device.close();
                }
                catch (_b) {
                }
            }
            this.openDevices.delete(path);
        });
    }
    call(path, name, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.cancelled = false;
            if (!this.messages) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            if (!this.openDevices.get(path)) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, `Device not acquired: ${path}`);
            }
            const protocol = this.deviceProtocol.get(path);
            if (!protocol) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, `Device protocol has not been detected for ${path}`);
            }
            if (protocol === 'V2') {
                return this.callProtocolV2(path, name, data, options);
            }
            return this.callProtocolV1(path, name, data, options);
        });
    }
    callProtocolV1(path, name, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { messages } = this;
            if (!messages) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            const encodeBuffers = ProtocolV1.encodeMessageChunks(messages, name, data);
            yield this.sendAllChunksWithRetry(path, encodeBuffers);
            const resData = yield this.receiveData(path, this.getOpenDevice(path), options === null || options === void 0 ? void 0 : options.timeoutMs);
            if (typeof resData !== 'string') {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.NetworkError, 'Returning data is not string.');
            }
            const jsonData = ProtocolV1.decodeMessage(messages, resData);
            return check.call(jsonData);
        });
    }
    cancel() {
        this.cancelled = true;
    }
    getOpenDevice(path) {
        const dev = this.openDevices.get(path);
        if (!dev) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, `Device not acquired: ${path}`);
        }
        return dev;
    }
    getErrorMessage(error) {
        if (!error)
            return '';
        if (typeof error === 'string')
            return error;
        if (typeof error === 'object' && 'message' in error) {
            const { message } = error;
            return typeof message === 'string' ? message : String(message !== null && message !== void 0 ? message : '');
        }
        return String(error);
    }
    isRetryableError(error) {
        const message = this.getErrorMessage(error).toLowerCase();
        if (message.includes('cancelled') || message.includes('canceled')) {
            return false;
        }
        return (message.includes('libusb') ||
            message.includes('transfer') ||
            message.includes('disconnected') ||
            message.includes('device not found') ||
            message.includes('busy') ||
            message.includes('pipe') ||
            message.includes('empty usb transfer') ||
            message.includes('network') ||
            message.includes('timeout') ||
            message.includes('interrupt'));
    }
    isUsbTransferTimeout(error) {
        const message = this.getErrorMessage(error).toLowerCase();
        return message.includes('timeout') || message.includes('timed_out');
    }
    getDeviceInterface(dev) {
        var _a;
        const { interfaces } = dev;
        if (!(interfaces === null || interfaces === void 0 ? void 0 : interfaces.length)) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, 'USB interface not found');
        }
        const vendorInterface = interfaces.find(iface => iface.descriptor.bInterfaceClass === 0xff);
        const defaultInterface = interfaces.find(iface => iface.descriptor.bInterfaceNumber === INTERFACE_NUMBER);
        const iface = (_a = vendorInterface !== null && vendorInterface !== void 0 ? vendorInterface : defaultInterface) !== null && _a !== void 0 ? _a : interfaces[0];
        return iface;
    }
    reconnectForRetry(path, direction, attempt, error) {
        const existing = this.reconnectLocks.get(path);
        if (existing)
            return existing;
        const doReconnect = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[NodeUsbTransport] transfer${direction} failed, retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(error)}`);
            yield hdShared.wait(attempt * PACKET_IO_RETRY_DELAY);
            yield this.rotateProtocolV2UsbGeneration(path, `Node USB Protocol V1 ${direction} reconnect attempt ${attempt}`);
            try {
                yield this.closeOpenDevice(path);
            }
            catch (releaseError) {
                (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug('[NodeUsbTransport] release before retry error:', releaseError);
            }
            yield this.enumerate();
            yield this.openDevice(path);
            const openDev = this.openDevices.get(path);
            if (!openDev) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, `Device not found after reconnect: ${path}`);
            }
            return openDev;
        });
        const promise = doReconnect().finally(() => {
            this.reconnectLocks.delete(path);
        });
        this.reconnectLocks.set(path, promise);
        return promise;
    }
    sendAllChunksWithRetry(path, encodeBuffers) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let lastError;
            for (let attempt = 1; attempt <= PACKET_IO_MAX_RETRIES; attempt++) {
                if (this.cancelled) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceInterruptedFromOutside, 'Cancelled');
                }
                try {
                    for (const buffer of encodeBuffers) {
                        const packet = new Uint8Array(PACKET_SIZE);
                        packet[0] = REPORT_ID;
                        packet.set(new Uint8Array(buffer), 1);
                        yield this.transferOutOnce(path, this.getOpenDevice(path).epOut, Buffer.from(packet));
                    }
                    return;
                }
                catch (error) {
                    lastError = error;
                    const shouldRetry = attempt < PACKET_IO_MAX_RETRIES && this.isRetryableError(error);
                    if (!shouldRetry) {
                        throw error;
                    }
                    try {
                        yield this.reconnectForRetry(path, 'out', attempt, error);
                    }
                    catch (reconnectError) {
                        lastError = reconnectError;
                        (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[NodeUsbTransport] reconnect failed on send retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(reconnectError)}`);
                        break;
                    }
                }
            }
            throw lastError;
        });
    }
    transferInWithRetry(path, openDev, length, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let lastError;
            let currentDev = openDev;
            for (let attempt = 1; attempt <= PACKET_IO_MAX_RETRIES; attempt++) {
                if (this.cancelled) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceInterruptedFromOutside, 'Cancelled');
                }
                try {
                    return yield this.transferInOnce(path, currentDev.epIn, length);
                }
                catch (error) {
                    lastError = error;
                    if ((options === null || options === void 0 ? void 0 : options.waitIndefinitelyOnTimeout) && this.isUsbTransferTimeout(error)) {
                        attempt -= 1;
                    }
                    else {
                        const shouldRetry = attempt < PACKET_IO_MAX_RETRIES && this.isRetryableError(error);
                        if (!shouldRetry) {
                            throw error;
                        }
                        try {
                            currentDev = yield this.reconnectForRetry(path, 'in', attempt, error);
                        }
                        catch (reconnectError) {
                            lastError = reconnectError;
                            (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[NodeUsbTransport] reconnect failed on retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(reconnectError)}`);
                            break;
                        }
                    }
                }
            }
            throw lastError;
        });
    }
    openDevice(path) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const existing = this.openDevices.get(path);
            if (existing)
                return;
            const busId = (_a = this.serialToBusId.get(path)) !== null && _a !== void 0 ? _a : path;
            const allDevices = usb__namespace.getDeviceList();
            const dev = allDevices.find(d => getBusId(d) === busId);
            if (!dev) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, `USB device not found: ${path}`);
            }
            try {
                dev.open();
                dev.timeout = TRANSFER_TIMEOUT_MS;
                const iface = this.getDeviceInterface(dev);
                if (process.platform === 'linux') {
                    try {
                        if (iface.isKernelDriverActive()) {
                            iface.detachKernelDriver();
                        }
                    }
                    catch (_d) {
                    }
                }
                iface.claim();
                const epIn = (_b = iface.endpoints.find((e) => e.direction === 'in' && e.address === ENDPOINT_IN)) !== null && _b !== void 0 ? _b : iface.endpoints.find((e) => e.direction === 'in');
                const epOut = (_c = iface.endpoints.find((e) => e.direction === 'out' && e.address === ENDPOINT_OUT)) !== null && _c !== void 0 ? _c : iface.endpoints.find((e) => e.direction === 'out');
                if (!epIn || !epOut) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, 'USB endpoints not found (expected IN 0x81, OUT 0x01)');
                }
                epIn.timeout = TRANSFER_TIMEOUT_MS;
                epOut.timeout = TRANSFER_TIMEOUT_MS;
                yield this.drainStaleInput(path, epIn);
                this.openDevices.set(path, { device: dev, iface, epIn, epOut });
            }
            catch (err) {
                try {
                    dev.close();
                }
                catch (_e) {
                }
                throw err;
            }
        });
    }
    drainStaleInput(path, epIn) {
        return __awaiter(this, void 0, void 0, function* () {
            const originalTimeout = epIn.timeout;
            epIn.timeout = 50;
            try {
                for (let index = 0; index < 16; index += 1) {
                    try {
                        yield this.transferInOnce(path, epIn, PACKET_SIZE);
                    }
                    catch (_a) {
                        break;
                    }
                }
            }
            finally {
                epIn.timeout = originalTimeout;
            }
        });
    }
    createProtocolMismatchError(expected) {
        return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, `Device protocol mismatch: expected ${expected}, but device did not respond to expected protocol`);
    }
    createProtocolDetectionError() {
        return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, 'Unable to detect USB protocol: device did not respond to Protocol V1 Initialize or Protocol V2 Ping');
    }
    detectProtocol(path, expectedProtocol, protocolHint) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (expectedProtocol === 'V2') {
                if (yield this.probeProtocolV2(path)) {
                    this.deviceProtocol.set(path, 'V2');
                    (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[NodeUsbTransport] detectProtocol: path=${path} -> V2 (expected)`);
                    return 'V2';
                }
                throw this.createProtocolMismatchError(expectedProtocol);
            }
            if (expectedProtocol === 'V1') {
                if (yield this.probeProtocolV1(path)) {
                    this.deviceProtocol.set(path, 'V1');
                    return 'V1';
                }
                throw this.createProtocolMismatchError(expectedProtocol);
            }
            const probeOrder = protocolHint === 'V2' || this.deviceProtocol.get(path) === 'V2' ? ['V2', 'V1'] : ['V1', 'V2'];
            for (const [index, protocol] of probeOrder.entries()) {
                if (index > 0) {
                    yield this.resetConnectionAfterProbe(path);
                }
                const detected = protocol === 'V1' ? yield this.probeProtocolV1(path) : yield this.probeProtocolV2(path);
                if (detected) {
                    this.deviceProtocol.set(path, protocol);
                    return protocol;
                }
            }
            this.deviceProtocol.delete(path);
            throw this.createProtocolDetectionError();
        });
    }
    resetConnectionAfterProbe(path) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.rotateProtocolV2UsbGeneration(path, 'Node USB protocol probe reset');
            try {
                yield this.cancelActiveTransfers(path);
                yield this.closeOpenDevice(path);
            }
            catch (error) {
                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[NodeUsbTransport] close after protocol probe error:', error);
            }
            yield this.enumerate();
            yield this.openDevice(path);
        });
    }
    withProtocolReadTimeout(path, promise, timeoutMs, protocol) {
        return __awaiter(this, void 0, void 0, function* () {
            let timer;
            let timedOut = false;
            const waitForeverAfterTimeout = () => new Promise(() => { });
            const guardedPromise = promise.then(value => (timedOut ? waitForeverAfterTimeout() : value), error => {
                if (timedOut) {
                    return waitForeverAfterTimeout();
                }
                throw error;
            });
            try {
                return yield Promise.race([
                    guardedPromise,
                    new Promise((_, reject) => {
                        timer = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                            var _a;
                            timedOut = true;
                            try {
                                yield this.resetConnectionAfterProbe(path);
                            }
                            catch (error) {
                                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[NodeUsbTransport] reset after Protocol ${protocol} timeout failed:`, error);
                            }
                            finally {
                                reject(new Error(`Protocol ${protocol} read timeout after ${timeoutMs}ms`));
                            }
                        }), timeoutMs);
                    }),
                ]);
            }
            finally {
                if (timer)
                    clearTimeout(timer);
            }
        });
    }
    probeProtocolV1(path) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.messages) {
                return false;
            }
            try {
                yield this.callProtocolV1(path, 'Initialize', {}, { timeoutMs: PROTOCOL_PROBE_TIMEOUT });
                return true;
            }
            catch (_error) {
                return false;
            }
        });
    }
    probeProtocolV2(path) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.messages || !this.messagesV2) {
                return false;
            }
            return transport.probeProtocolV2({
                call: (name, data, options) => this.callProtocolV2(path, name, data, options),
                timeoutMs: PROTOCOL_PROBE_TIMEOUT,
                logger: this.Log,
                logPrefix: 'ProtocolV2 NodeUSB',
                onProbeFailed: () => this.resetConnectionAfterProbe(path),
            });
        });
    }
    getProtocolV2UsbSchemas() {
        if (!this.messages || !this.messagesV2) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
        }
        return {
            protocolV1: this.messages,
            protocolV2: this.messagesV2,
        };
    }
    getProtocolV2UsbLogger() {
        return this.Log;
    }
    writeProtocolV2UsbPacket(path, frame, _context) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cancelled) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceInterruptedFromOutside, 'Cancelled');
            }
            yield this.transferOutOnce(path, this.getOpenDevice(path).epOut, Buffer.from(frame));
        });
    }
    readProtocolV2UsbPacket(path, _context) {
        return __awaiter(this, void 0, void 0, function* () {
            for (;;) {
                if (this.cancelled) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceInterruptedFromOutside, 'Cancelled');
                }
                try {
                    const packet = yield this.transferInOnce(path, this.getOpenDevice(path).epIn, transport.PROTOCOL_V2_FRAME_MAX_BYTES);
                    return new Uint8Array(packet.buffer.slice(packet.byteOffset, packet.byteOffset + packet.byteLength));
                }
                catch (error) {
                    if (!this.isUsbTransferTimeout(error)) {
                        throw error;
                    }
                }
            }
        });
    }
    resetProtocolV2UsbNativeLink(path, _reason) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cancelActiveTransfers(path);
            yield this.closeOpenDevice(path);
        });
    }
    onProtocolV2UsbLinkInvalidated(path, reason) {
        var _a;
        this.deviceProtocol.delete(path);
        (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[NodeUsbTransport] Protocol V2 link invalidated: ${path}`, reason);
    }
    createProtocolV2UsbTimeoutError(name, timeoutMs) {
        return new transport.ProtocolV2LinkError('response-timeout', `Protocol V2 response timeout after ${timeoutMs}ms for ${name}`);
    }
    callProtocolV2(path, name, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callProtocolV2Usb(path, name, data, options);
        });
    }
    receiveData(path, dev, timeoutMs) {
        return __awaiter(this, void 0, void 0, function* () {
            const deadline = timeoutMs ? Date.now() + timeoutMs : undefined;
            const readPacket = () => __awaiter(this, void 0, void 0, function* () {
                const transferIn = this.transferInWithRetry(path, this.getOpenDevice(path), PACKET_SIZE);
                return deadline
                    ? this.withProtocolReadTimeout(path, transferIn, Math.max(deadline - Date.now(), 1), 'V1')
                    : transferIn;
            });
            const firstPacket = timeoutMs
                ? yield readPacket()
                : yield this.transferInWithRetry(path, dev, PACKET_SIZE);
            const firstData = skipReportByte(firstPacket);
            const { length, typeId, restBuffer } = ProtocolV1.decodeFirstChunk(toArrayBuffer(firstData));
            const lengthWithHeader = Number(length) + HEADER_LENGTH;
            const decoded = new ByteBuffer__default["default"](lengthWithHeader);
            decoded.writeUint16(typeId);
            decoded.writeUint32(Number(length));
            if (length) {
                decoded.append(restBuffer);
            }
            while (decoded.offset < lengthWithHeader) {
                const packet = yield readPacket();
                const pktData = skipReportByte(packet);
                const buf = toArrayBuffer(pktData);
                if (lengthWithHeader - decoded.offset >= PAYLOAD_SIZE) {
                    decoded.append(buf);
                }
                else {
                    decoded.append(buf.slice(0, lengthWithHeader - decoded.offset));
                }
            }
            decoded.reset();
            const result = decoded.toBuffer();
            return Buffer.from(result).toString('hex');
        });
    }
    getProtocolType(path) {
        return this.deviceProtocol.get(path);
    }
}

module.exports = NodeUsbTransport;
